$(document).ready(function () {
    var group;

    $('#add-new-eportfolio-group-btn, .edit-eportfolio-group').on('click', function () {
        group = undefined;
    });

    $('#addediteportfoliogroup').on('shown.bs.modal', function (e) {
        // Reset form
        var form = this.querySelector('form');
        form.reset();

        // Clear any previous validation errors
        $(form).find('.error-message').remove();
        $(form).find('.has-error').removeClass('has-error');

        $('#submission-warning').hide();
        $('.move-group-member-btn').show();

        if ($(e.relatedTarget).data('group') !== undefined) {
            group = $(e.relatedTarget).data('group');
        }

        var modal = $(this);
        var members_select_box = $(modal).find('select[name="users[]"]');
        var modal_title = $(modal).find('span.title');
        var group_title_box = $(modal).find('input[type="text"][name="name"]');
        var acyr = $(modal).find('input[type="hidden"][name="acyr"]');
        var degreeprogyr = $(modal).find('input[type="hidden"][name="degreeprogyr"]');
        var group_id = $(modal).find('input[type="hidden"][name="id"]');

        // Clear select2 properly before reinitializing
        if (members_select_box.hasClass('select2-hidden-accessible')) {
            members_select_box.select2('destroy');
        }

        members_select_box.empty();

        if (group === undefined) {
            $(modal_title).text('Create Group');
            $(group_title_box).val('');
            $(group_title_box).unbind('keyup');
            $(group_id).val('');
            $(acyr).val($('ul.acyr-filter li.active').text().trim());
            $(degreeprogyr).val($('ul.degreeprogyr-filter li.active').text().trim());
            $('.move-group-member-btn').hide();
        } else {
            $(modal_title).text('Edit Group: ' + group.name);
            $(group_title_box).val(group.name);
            $(group_title_box).on('keyup', function () {
                $(modal_title).text('Edit Group: ' + $(group_title_box).val());
            });

            $(group_id).val(group.id);
            $(acyr).val(group.acyr);
            $(degreeprogyr).val(group.degreeprogyr);

            if (group.users.length > 0) {
                $.each(group.users, function (idx, user) {
                    var type = '';
                    var submitted = '';
                    var fullname = '';
                    if (user.basicrole === 'basic') {
                        type = 'Student';
                    } else {
                        type = 'Staff';
                    }
                    if (user.submission_id !== null) {
                        $('#submission-warning').show();
                        submitted = ' - Submitted';
                    }
                    fullname = user.firstname + ' ' + user.lastname + ' (' + type + ')';
                    $(members_select_box).append('<option selected value="' + user.id + '" title="' + fullname + submitted + '">' + fullname + '</option>');
                });
            } else {
                $('.move-group-member-btn').hide();
            }
        }

        function formatUser(user) {
            return user.name + ' (' + (user.basicrole === 'basic' ? 'Student' : 'Staff') + ')';
        }

        function fetchUser(term, programmeYear) {
            return $.ajax({
                url: base_url + 'eportfolio/ajax_users',
                dataType: 'json',
                type: 'GET',
                data: {
                    programmeYear: programmeYear,
                    term: term,
                },
            });
        }

        function addUserToSelect(select, user) {
            const optionExists = select.find('option[value="' + user.id + '"]').length > 0;
            if (optionExists === false) {
                const option = new Option(formatUser(user), user.id, true, true);
                select.append(option).trigger('change');
            }
        }

        $(members_select_box).select2({
            width: '100%',
            theme: 'bootstrap',
            minimumInputLength: 3,
            ajax: {
                url: base_url + 'eportfolio/ajax_users',
                dataType: 'json',
                delay: 250,
                type: 'GET',
                data: function (params) {
                    return {
                        term: params.term,
                    };
                },
                processResults: function (data) {
                    return {
                        // Workaround for Select2 4.1.0 Ajax search issue (GitHub issue #6423)
                        results: $.map(data, user => ({ id: user.id, text: formatUser(user), _resultId: 'eportfolio-user-result-' + user.id })),
                    };
                },
            },
            templateSelection: item => item.text,
        });

        // Trigger change after select2 initialisation if editing group
        if (group !== undefined) {
            members_select_box.trigger('change');
            members_select_box.on('select2:unselecting', function (e) {
                // eslint-disable-next-line @stylistic/max-statements-per-line
                const unselectedUser = group.users.find((object) => { return object['id'] === e.params.args.data.id });
                // Disable selection if student has a submission
                if (unselectedUser !== undefined && unselectedUser.submission_id !== null) {
                    e.preventDefault();
                }
            });
        }

        // Handle pasting a list of emails
        $(members_select_box).off('select2:open.multiplePaste')
            .on('select2:open.multiplePaste', function () {
                const searchInput = $('.select2-container--open .select2-search__field');

                searchInput.off('paste.multiplePaste').on('paste.multiplePaste', function (e) {
                    const clipboardData = e.originalEvent.clipboardData || window.clipboardData;
                    const pastedText = (clipboardData.getData('text') || '')
                        .replaceAll(/[\r\n]+/g, ' ')
                        .trim();

                    const terms = pastedText
                        .split(/[\s,]+/)
                        .map(term => term.trim().toLowerCase())
                        .filter(term => term.length);

                    function isValidEmail(email) {
                        // Email validation
                        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
                    }

                    if (terms.every(isValidEmail) === false) {
                        return;
                    }

                    e.preventDefault();

                    const select        = $(members_select_box);
                    const programmeYear = $(degreeprogyr).val();

                    for (const term of terms) {
                        fetchUser(term, programmeYear).done((data) => {
                            if (data && data.length > 0) {
                                addUserToSelect(select, data[0]);
                            }
                        });
                    }
                });
            });

        addDisabledStyling();

        $(members_select_box).on('change', function () {
            // A timeout is needed in order to force this to run after select2 has rendered
            setTimeout(function () {
                addDisabledStyling();
            });
        });
    });

    // Apply disabled styling to any students with a submission
    function addDisabledStyling() {
        const elements = document.querySelectorAll('li[title*="Submitted"]');

        for (const element of elements) {
            element.style.backgroundColor = '#d5d5d5';

            // Remove text suffix safely (- Submitted) without affecting other parts of the name
            const display = element.querySelector('.select2-selection__choice__display');

            if (display) {
                display.textContent = display.textContent.replace(' - Submitted', '');
            }

            // Hide the remove button if required, so that users cannot remove students with submissions
            const removeButton = element.querySelector('.select2-selection__choice__remove');

            if (removeButton) {
                removeButton.style.display = 'none';
            }
        };
    }

    $('#movegroupmembers').on('shown.bs.modal', function () {
        const form = this.querySelector('form');
        form.reset();

        // Clear any previous validation errors
        $(form).find('.error-message').remove();
        $(form).find('.has-error').removeClass('has-error');

        var modal = $(this);
        var members_select_box = $(modal).find('select[name="users[]"]');
        var groups_select_box = $(modal).find('select[name="movetogroupid"]');
        var modal_title = $(modal).find('span.title');
        var acyr = $(modal).find('input[type="hidden"][name="acyr"]');
        var degreeprogyr = $(modal).find('input[type="hidden"][name="degreeprogyr"]');
        var group_id = $(modal).find('input[type="hidden"][name="currentgroupid"]');

        $(modal_title).text('Move Group Members from: ' + group.name);
        $(group_id).val(group.id);
        $(acyr).val(group.acyr);
        $(degreeprogyr).val(group.degreeprogyr);

        // Clear select2 properly
        if (members_select_box.hasClass('select2-hidden-accessible')) {
            members_select_box.select2('destroy');
        }

        members_select_box.empty();

        $.each(group.users, function (idx, user) {
            var type = '';
            if (user.basicrole === 'basic') {
                type = 'Student';
            } else {
                type = 'Staff';
            }
            $(members_select_box).append(new Option(user.firstname + ' ' + user.lastname + ' (' + type + ')', user.id));
            if (user.submission_id !== null) {
                $('#submission-warning').show();
            }
        });

        if (groups_select_box.hasClass('select2-hidden-accessible')) {
            groups_select_box.select2('destroy');
        }
        groups_select_box.empty().append('<option disabled selected>Select a group</option>');
        $.each(allgroups, function (idx, groupOption) {
            if (groupOption.id !== group.id) {
                $(groups_select_box).append(new Option(groupOption.name, groupOption.id));
            }
        });

        $(members_select_box).select2({
            width: '100%',
            theme: 'bootstrap',
            placeholder: 'Select group members',
            templateSelection: function (item) {
                return item.text;
            },
        });

        $(groups_select_box).select2({
            theme: 'bootstrap',
            width: '100%',
        });

        members_select_box.trigger('change');
        groups_select_box.trigger('change');
    });

    // Validation for add/edit group form
    $('#add-edit-eportfolio-group-form').on('submit', function (e) {
        var $form = $(this);
        var $nameField = $form.find('input[name="name"]');
        var isValid = true;

        // Clear previous errors
        $form.find('.error-message').remove();
        $form.find('.has-error').removeClass('has-error');

        // Validate name field
        if ($nameField.val().trim() === '') {
            isValid = false;
            $nameField.closest('.form-group').addClass('has-error');
            $nameField.after('<span class="error-message text-danger">Please enter a name for the ePortfolio group</span>');
        }

        if (!isValid) {
            e.preventDefault();
            return false;
        }

        // Disable submit button to prevent double submission
        $('.submit-btn').prop('disabled', true).html('<i class="fa-regular fa-save"></i> Saving...');
    });

    // Validation for move group members form
    $('#move-eportfolio-group-members-form').on('submit', function (e) {
        var $form = $(this);
        var $usersField = $form.find('select[name="users[]"]');
        var $groupField = $form.find('select[name="movetogroupid"]');
        var isValid = true;

        // Clear previous errors
        $form.find('.error-message').remove();
        $form.find('.has-error').removeClass('has-error');

        // Validate users field
        if (!$usersField.val() || $usersField.val().length === 0) {
            isValid = false;
            $usersField.closest('.form-group').addClass('has-error');
            $usersField.next('.select2-container').after('<span class="error-message text-danger">Please select one or more group members to move</span>');
        }

        // Validate group field
        if (!$groupField.val() || $groupField.val() === 'Select a group') {
            isValid = false;
            $groupField.closest('.form-group').addClass('has-error');
            $groupField.next('.select2-container').after('<span class="error-message text-danger">Please select a group to move to</span>');
        }

        if (!isValid) {
            e.preventDefault();
            return false;
        }

        // Disable submit button to prevent double submission
        $('.submit-btn').prop('disabled', true).html('<i class="fa-regular fa-save"></i> Saving...');
    });

    $('#copyeportfoliogroups').on('show.bs.modal', function (e) {
        var modal               = $(this);
        var modal_title         = $(modal).find('span.title');
        var timetablegroups     = $('#timetablegroups');
        var eportfolioyeargroup = $('#eportfolioyeargroup');
        var btnselectgroups     = $('.btn-selectgroups');
        var acyr                = $('ul.acyr-filter li.active').text().trim();

        $(modal_title).text('Copy Groups from Timetable');

        eportfolioyeargroup.on('change', function () {
            var degprgyr    = $(this).find(':selected').val();
            var groupname   = $(this).find(':selected').text();
            var ajaxloading = $('.ajaxloading');
            $.ajax({
                type: 'GET',
                url: base_url + 'eportfolio/ajax_groups',
                data: { degreeprogrammeyear: degprgyr, acyr: acyr },
                dataType: 'json',
                beforeSend: function () {
                    $(ajaxloading).html('<i class="' + FontAwesome.prefix('solid', 'spinner', true) + '"></i> Loading Groups....');
                },
                success: function (groups) {
                    ajaxloading.empty();
                    btnselectgroups.show();

                    var groups_html = $.map(groups, function (group) {
                        if (group.iswardteaching == 0) {
                            return '<li><input type="checkbox" id="' + group.id + '" name="groups[]" title="' + group.name + ' (' + group.acyr + ')" value="' + group.id + '" /> <label role="button" for="' + group.id + '">' + group.name + ' (' + group.acyr + ') (' + group.user_count + ' students)</label></li>';
                        }
                    }).join('');

                    timetablegroups.empty()
                        .append(groups_html);
                },
            });
        });
        btnselectgroups.click(function () {
            $(this).prop('disabled', true)
                .html('<i class="' + FontAwesome.prefix('solid', 'spinner', true) + '"></i> Building Groups....')
                .parents('form').submit();
        });
    });

    $('#deleteeportfoliogroup').on('show.bs.modal', function (e) {
        var group = $(e.relatedTarget).data('group');
        var modal = $(this);

        $(modal).find('span.group-name').html(group.name);
        $(modal).find('a.delete-button').prop('href', base_url + 'eportfolio/deletegroup/' + group.id);
    });
});
